import React from 'react';

interface LoadingSpinnerProps {
  inline?: boolean;
  message?: string;
}

export default function LoadingSpinner({ inline = false, message }: LoadingSpinnerProps) {
  if (inline) {
    return (
      <span className="inline-flex items-center">
        <span className="inline-block animate-spin rounded-full h-4 w-4 border-b-2 border-gray-900"></span>
        {message && <span className="ml-2">{message}</span>}
      </span>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
        {message && <p className="mt-2 text-gray-600">{message}</p>}
      </div>
    </div>
  );
}